import { MutationHookOptions, useMutation } from "@apollo/client";

import {
    ProjectReviewVisitV2Screen_PlannerVisitApproveDocument,
    ProjectReviewVisitV2Screen_PlannerVisitRejectDocument,
} from "../mutations.generated";

export function useReviewVisitDecisionActions({
    visitId,
    refetchQueries,
}: {
    visitId: string;
    refetchQueries: MutationHookOptions["refetchQueries"];
}) {
    const [approveMutation, { loading: approveLoading }] = useMutation(ProjectReviewVisitV2Screen_PlannerVisitApproveDocument, {
        refetchQueries,
    });

    const [rejectMutation, { loading: rejectLoading }] = useMutation(ProjectReviewVisitV2Screen_PlannerVisitRejectDocument, {
        refetchQueries,
    });

    return {
        handleApprove: async () => {
            await approveMutation({ variables: { plannerVisitId: visitId } });
        },
        handleReject: async (rejectionReason: string) => {
            await rejectMutation({ variables: { plannerVisitId: visitId, rejectionReason } });
        },

        loading: approveLoading || rejectLoading,
    };
}
